// Production Release 0.1.2
// Deployed: David Nelson
import React, { Component, Fragment } from "react";
import { Dialog } from "./components/index.js";
import {
  LocateUser,
  ConfirmCustomer,
  ConfirmService,
  ConfirmDestination,
  ConfirmInformation,
  LocatingProviderContainer,
  PaymentRequiredContainer,
  ProviderEnroute,
  Feedback,
  DebugMenu,
  SplashScreen,
} from "./views";
import TTLocateUser from "./views/TTLocateUser/TTLocateUser.jsx";
import ConfirmVehicle from "./views/ConfirmVehicle/ConfirmVehicle.jsx";
import { Modal } from "react-responsive-modal";

import moment from "moment";
import { withTranslation } from "react-i18next";

import { hotjar } from "react-hotjar";

import TrxNowLocateUser from "./views/TrxNowLocateUser/TrxNowLocateUser";
import { devLog } from "utils/devLog";

// API Imports
import {
  apiLoginCompany,
  apiCreateCall,
  apiGetCall,
  apiGetCallPending,
  apiGetCallStatus,
  apiSetSubmitStage,
  apiCancelCall,
  apiCancelCallPending,
  apiFeedbackSubmit,
  apiGetFeedbackStatus,
  apiSetDeflected,
  apiGetAppConfig,
} from "utils/API/TrxNowAPI";

// Having issues testing with local storage. removing for now - DRN
import { /*localStorer,*/ localStorageGetter, clearLocalStorage, asyncRevGeocodeLocationGoogle } from "utils/util.js";

//
import "bootstrap/dist/css/bootstrap.min.css";
import "./views/styles.scss";
import "react-responsive-modal/styles.css";
import "webapp/styles/dialog.scss";

import DestMapMarker from "assets/ui-img/map-markers/markerServiceLocation.png";
import TowMapMarker from "../assets/ui-img/map-markers/markerTow.png";

import {
  removeAllMarker,
  addMarkertoMapGroup,
  addMarkertoMapGroupNoCenter,
} from "utils/here-maps/newHereMapFunctions.js";
import { countryFind } from "utils/constants/CountryLookUp.js";
import { FindPartner } from "utils/Partners.js";
import TrxNowMap from "./components/TrxNowMap/TrxNowMap.jsx";
import TrxNowGeoLocation from "./components/TrxNowMap/TrxNowGeoLocation.jsx";
import { fontSize } from "@mui/system";
import SelectDestination from "./views/SelectDestination/SelectDestination.jsx";
//basic dictionary, that we use for view management, for the application as a whole.
import { AppState } from "./enums/AppState.js";
import NavigationService from "./services/NavigationService.js";
import MemberSearchService from "./services/MemberSearchService.js";
import WelcomeModal from "./components/WelcomeModal/WelcomeModal.jsx";
import TVLAccidentConfirmed from "./views/Partner/TVL/TVLAccidentConfirmed/TVLAccidentConfirmed.jsx";
import { getCountryCode } from "utils/GeoLocation.js";
import { ARIAccidentConfirmed } from "./views/Partner/ARI/ARIAccidentConfirmed/index.js";
import GenericMemberSearch from "./views/Partner/Generic/GenericMemberSearch/GenericMemberSearch.jsx";
import GenericMemberInformation from "./views/Partner/Generic/GenericMemberInformation/GenericMemberInformation.jsx";
import ApiPendingScreen from "./views/ApiPendingScreen/ApiPendingScreen.jsx";
import PartnerPromotion from "./views/PartnerPromotion/PartnerPromotion.jsx";

// This is the delay between getCallStatus API Calls
const REFRESH_DELAY = 30000; // 30s
const bUseLocalStorageState = false;

/**v
 * WebAppViewPre class.
 *
 * this component class that handles the global state and screen routing
 */
class WebAppViewPre extends Component {
  state = {
    initialized: false,
    clientApp: false,
    ShowDebugControls: false,
    // Used to track the state of the application
    showWelcomeModal: false,
    webAppState: AppState.Blank, //naviService.defaultState // default is AppState.LocateUser
    // prevWebAppState: naviService.defaultState,
    CanRunCycler: false,
    // Map Data
    mapObject: {
      H: null,
      hMap: null,
    },
    towReasonRestricted: false,
    // Disablement Location Info
    DisablementObject: {},
    DisablementAddress: "",
    HasPark: false,
    DisablementStreet: "",
    DisablementCity: "",
    DisablementState: "",
    DisablementZip: "",
    DisablementCountry: "",
    DisablementCoords: {
      //lat: 36.317126,
      //lng: -82.351134,
    },
    // Customer Information
    CustomerInfoObject: {}, // TODO: Refactor to use this
    FirstName: "",
    LastName: "",
    Number: "", // ! refactor to PhoneNumber
    PolicyNumber: "",
    MemberLookup: {
      FirstName: "",
      LastName: "",
      Phone: "",
      MemberNumber: "",
      AgreementNum: "",
      VIN: "",
      Odometer: "",
      Last8VIN: "",
      LicensePlate: "",
      ProvinceCode: "",
      ClientID: "",
      v: "",
      ServiceCardNum: "",
      towReason: "",
    },
    last8Vin: "",
    // Vehicle Information
    VecicleObject: {}, // TODO: Refactor to use this
    VIN: "",
    Year: "",
    Make: "",
    Model: "",
    Color: "",
    Odometer: 0,
    Service: "",
    Provider: "",
    WillRemainWithAuto: false,
    OnHighway: "",
    // destination information
    DestinationObj: {}, // TODO: Refactor to use this
    DestinationAddress: "",
    DestinationCompany: "",
    DestinationStreet: "",
    DestinationCity: "",
    DestinationState: "",
    DestinationZip: "",
    DestinationCountry: "",
    DestinationCoords: {
      lat: null,
      lng: null,
    },
    CallCoords: {},
    ServiceDetails: "",
    CSSCallBackFlag: true,
    userAddressObject: null,
    userCoords: null,
    ConfirmInfoFlag: false,
    // API Call Data Model Items
    currentCompanyParams: {},
    CallStatus: {},
    CallPendingParams: {},
    tokenID: "",
    providerRef: "",
    accountRef: "",
    memberRef: "",
    localGroup: "",
    ShouldProcessAPI: false,
    CallStatusMessage: "",
    EnRouteData: {
      time: "12:21 pm",
      servProv: "Tristan Towing",
      status: "on the way",
      cancelFlag: false,
      helpFlag: false,
    },
    OperatorName: "",
    OperatorBusinessName: "",
    OperatorPhoneNumber: "555-555-5555",
    OperatorCoords: {
      lat: 36.334498662,
      lng: -82.370331852,
    }, // ! debug only!
    CallETA: "",
    ProviderEnRouteDest: false,
    // CallStatusParams
    CallStatusParams: {
      QuoteAmt: 4200,
      Currency: "USD",
      encCallGUID: "",
    },
    // Feedback Information
    FeedbackObj: {},
    // Feedback Information
    TTLObj: {
      lat: 0,
      lng: 0,
      street: "",
      city: "",
      state: "",
      country: "",
      zip: "",
    },
    // Error Alert Information
    ShowMessage: false,
    MessageTitle: "",
    Message: "",
    // When true (e.g. ECC transit-provider notice): hide modal X / overlay-dismiss, and optionally hide footer primary pill.
    MessagePreventDismiss: false,
    MessageHidePrimaryButton: false,
    ShowHelp: false,
    FuelType: "",
    lang: "",
    localGroupLogo: "",
    firstEnrouteRender: true,
    userDeniedLocation: false,
    isAutoAccept: false,
    disableAutoAccept: false,
    ReturnToConfirm: false,
    TVLAccidentQuationAsked: null,
    ARIAccidentQuationAsked: null,
    allowVehicleInfoEdits: true,
    deflectionOverride: true,
    ContractNumber: null,
    GeoLocationStatus: "PENDING",
    navigationService: NavigationService.getService(),
    recommendation: "",
    autoSearchRequired: null,
    skipMemberSearchLimit: 0,
  };
  constructor(props) {
    super(props);

    //legacy function which originally stored and retrieved information from local storage
    clearLocalStorage();
    const test = localStorageGetter();
    devLog("test localStorage:", test);
    const naviService = NavigationService.getService();
    const memberSearchService = MemberSearchService.getService();
    devLog("memberSearchService: ", memberSearchService);
    if (test === null) {
      this.state = {
        initialized: false,
        navigationService: naviService,
        memberSearchService: memberSearchService,
        ShowDebugControls: false,
        // Used to track the state of the application
        showWelcomeModal: false,
        webAppState: AppState.Blank, //naviService.defaultState // default is AppState.LocateUser
        prevWebAppState: naviService.defaultState,
        CanRunCycler: false,
        towReasonRestricted: false,
        CompletedSteps: {
          MemberIdentification: false,
          VehicleInfo: false,
          ServiceType: false,
          Disablement: false,
          Destination: false,
        },
        // Map Data
        mapObject: {
          H: null,
          hMap: null,
        },
        // Disablement Location Info
        DisablementObject: {},
        DisablementAddress: "",
        HasPark: false,
        DisablementStreet: "",
        DisablementCity: "",
        DisablementState: "",
        DisablementZip: "",
        DisablementCountry: "",
        DisablementCoords: {
          //lat: 36.317126,
          //lng: -82.351134,
        },
        // Customer Information
        CustomerInfoObject: {}, // TODO: Refactor to use this
        FirstName: "",
        LastName: "",
        Number: "", // ! refactor to PhoneNumber
        PolicyNumber: "",
        MemberLookup: {
          FirstName: "",
          LastName: "",
          Phone: "",
          MemberNumber: "",
          VIN: "",
          Odometer: "",
          Last8VIN: "",
          LicensePlate: "",
          ProvinceCode: "",
          ClientID: "",
          v: "",
          ServiceCardNum: "",
        },
        last8VIN: "",
        // Vehicle Information
        VecicleObject: {}, // TODO: Refactor to use this
        VIN: "",
        Year: "",
        Make: "",
        Model: "",
        Color: "",
        Odometer: 0,
        Service: "",
        Provider: "",
        WillRemainWithAuto: false,
        OnHighway: "",
        // destination information
        DestinationObj: {}, // TODO: Refactor to use this
        DestinationAddress: "",
        DestinationCompany: "",
        DestinationStreet: "",
        DestinationCity: "",
        DestinationState: "",
        DestinationZip: "",
        DestinationCountry: "",
        DestinationCoords: {
          lat: null,
          lng: null,
        },
        CallCoords: {},
        ServiceDetails: "",
        CSSCallBackFlag: true,
        userAddressObject: null,
        userCoords: null,
        ConfirmInfoFlag: false,
        // API Call Data Model Items
        currentCompanyParams: {},
        CallStatus: {},
        CallPendingParams: {},
        tokenID: "",
        providerRef: "",
        accountRef: "",
        memberRef: "",
        contactRef: "",
        localGroup: "",
        ShouldProcessAPI: false,
        CallStatusMessage: "",
        EnRouteData: {
          time: "12:21 pm",
          servProv: "Tristan Towing",
          status: "on the way",
          cancelFlag: false,
          helpFlag: false,
        },
        OperatorName: "",
        OperatorBusinessName: "",
        OperatorPhoneNumber: "555-555-5555",
        OperatorCoords: {
          lat: 36.334498662,
          lng: -82.370331852,
        }, // ! debug only!
        CallETA: "",
        ProviderEnRouteDest: false,
        // CallStatusParams
        CallStatusParams: {
          QuoteAmt: 4200,
          Currency: "USD",
          encCallGUID: "",
        },
        // Feedback Information
        FeedbackObj: {},
        // Feedback Information
        TTLObj: {
          lat: 0,
          lng: 0,
          street: "",
          city: "",
          state: "",
          country: "",
          zip: "",
        },
        // Error Alert Information
        ShowMessage: false,
        MessageTitle: "",
        Message: "",
        ShowHelp: false,
        FuelType: "",
        lang: "",
        localGroupLogo: "",
        firstEnrouteRender: true,
        userDeniedLocation: false,
        isAutoAccept: false,
        disableAutoAccept: false,
        ReturnToConfirm: false,
        TVLAccidentQuationAsked: null,
        ARIAccidentQuationAsked: null,
        allowVehicleInfoEdits: true,
        deflectionOverride: true,
        ContractNumber: null,
        GeoLocationStatus: "PENDING",
        apiCallPending: false,
        cancelCallPendingLoading: false,
        autoSearchRequired: null,
        skipMemberSearchLimit: 0,
      };
    } else {
      //devLog(test)
      this.state = test;
    }

    // bind functions for this.state access
    this.startButtonPressed = this.startButtonPressed.bind(this);
    this.prepareAndCreateCall = this.prepareAndCreateCall.bind(this);
    this.runCallCycler = this.runCallCycler.bind(this);
    this.processServerResponse = this.processServerResponse.bind(this);
    this.callProvider = this.callProvider.bind(this);
    //this.languageChange = this.languageChange(this);
  }

  componentDidMount() {
    // init hotjarf
    hotjar.initialize(2710234, 6);

    // on load we'll make some initial
    // api calls and grab the query params
    if (window.location.href.includes("partnerPromotion")) {
      devLog("Checking in with partnerPromotion");
      this.checkInWithServerPartnerPromotion();
    } else if (window.location.href.includes("feedback")) {
      devLog("Checking in with feedback");
      this.checkInWithServerFeedback();
    } else if (window.location.href.includes("webapp-ttl")) {
      devLog("Checking in with webapp-ttl");
      this.checkInWithServerTTL();
    } else {
      devLog("Checking in with server normally");
      this.checkInWithServer();
    }

    // try{
    // 	window.addEventListener("popstate", (event) => { this.onPopState(event); });
    // }catch(e){ console.error(e); }
  }

  // onPopState(event) {
  // 	devLog('onPopState', event, this.state);
  // }

  /**
   * startButtonPressed()
   * This is a callback function passed to the Dialog callback
   * and allows us to log their interaction with the start button
   * @memberof WebAppView
   */
  startButtonPressed() {
    apiSetSubmitStage(this.state, 1, this.state.DisablementAddress || "DisablementAddress Not Available");
  }

  componentDidUpdate(prevProps, prevState) {
    // devLog("componentDidUpdate");
    if (
      prevState.ShowMessage &&
      !this.state.ShowMessage &&
      (prevState.MessagePreventDismiss || prevState.MessageHidePrimaryButton)
    ) {
      this.setState({
        MessagePreventDismiss: false,
        MessageHidePrimaryButton: false,
      });
    }

    if (this.state.webAppState !== AppState.LocateUser) {
    }

    const naviService = this.state.navigationService;
    if (!naviService) {
      return;
    }
    // devLog("naviService: found");

    const naviState = naviService.getState(this.state.webAppState);
    if (!naviState) {
      return;
    }
    // devLog("naviState: found", naviState);

    if (naviState && naviState.params && !!naviState.params.isHomeScreen) {
      this.state.showWelcomeModal = true;
    }

    this.state.apiCallPending = !!this.state.apiCallPending;
  }

  /**
   * Cahces the current state of the application in localStorage
   * @param {WebAppState} context
   * @returns void
   */
  saveWebAppState(context) {
    if (!context || !bUseLocalStorageState) {
      return;
    }
    devLog("saveWebAppState: Saving...");
    try {
      window.localStorage.setItem("webAppState", context.state.webAppState);
      window.localStorage.setItem("providerRef", context.state.providerRef);
      window.localStorage.setItem("appState", JSON.stringify(context.state));
      devLog("saveWebAppState: Saved!");
    } catch (e) {
      devLog("saveWebAppState: Error!");
      console.error(e);
    }
  }

  setAsyncState = (newState) => new Promise((resolve) => this.setState(newState, resolve));

  /**
   * checkInWithServer()
   * This function calls a series of API calls
   * that login with the server and get all needed
   * information for future calls. It also checks if
   * an existing call is in progress.
   * @memberof WebAppView
   */
  async checkInWithServer() {
    devLog("checkInWithServer: Executed");
    const naviService = this.state.navigationService;
    // grab query params and save to state
    this.getAndSaveQueryParams(() => {
      devLog("getAndSaveQueryParams: Executed");
      // loginCompany to get tokenid and guid
      apiLoginCompany(this.state, (companyParams) => {
        devLog("apiLoginCompany: Executed");
        let cachedWebAppState;
        let appState;

        try {
          if (bUseLocalStorageState && this.state.providerRef === window.localStorage?.getItem("providerRef")) {
            cachedWebAppState = parseInt(localStorage?.getItem("webAppState"));
            let cachedAppState = JSON.parse(localStorage?.getItem("appState"));
            if (!!cachedAppState && typeof cachedAppState === "object") {
              cachedAppState.navigationService = NavigationService.getService();
              this.setState({ ...cachedAppState });
            }
          }
        } catch (e) {
          console.error(e);
        }

        // this.setWebAppState(this, AppState.SelectService);

        appState = !isNaN(cachedWebAppState) ? cachedWebAppState : naviService.defaultState;
        this.setState(
          {
            currentCompanyParams: companyParams,
            webAppState: appState,
          },
          async () => {
            /**
             * Get Application Boot Config
             */
            let appConfig;
            try {
              if (!this.state.providerRef) {
                throw new Error(`Failed to get appConfig: Invalid ProviderRef`);
              }
              devLog("apiGetAppConfig: Executed");
              appConfig = await apiGetAppConfig(this.state);
              devLog("apiGetAppConfig: ", appConfig);
            } catch (e) {
              console.error("apiGetAppConfig error: ", e);
            }

            try {
              if (!!appConfig) {
                const bHasDisablementCoords = appConfig?.latitude && appConfig?.longitude;
                const disablementCoords = bHasDisablementCoords
                  ? {
                      lat: appConfig?.latitude,
                      lng: appConfig?.longitude,
                    }
                  : this.state.DisablementCoords || {
                      lat: undefined,
                      lng: undefined,
                    };

                let DisablementInfo = {
                  GeoLocationStatus: this.state.GeoLocationStatus,
                  DisablementAddress: this.state.DisablementAddress,
                  DisablementStreet: this.state.DisablementStreet,
                  DisablementCity: this.state.DisablementCity,
                  DisablementState: this.state.DisablementState,
                  DisablementZip: this.state.DisablementZip,
                  DisablementCountry: this.state.DisablementCountry,
                };

                let bCanAutoGeoLocate = this.state.localGroup == "ARIU" || this.state.localGroup == "ARIC";
                let bCanCacheLastVistedView =
                  (this.state.localGroup == "ARIU" || this.state.localGroup == "ARIC") && this.state.contactRef;
                try {
                  if (bHasDisablementCoords && bCanAutoGeoLocate) {
                    const geoCodeResults = await asyncRevGeocodeLocationGoogle(appConfig);
                    if (geoCodeResults.address) {
                      const address = geoCodeResults.address.address;
                      let locationStreet = address.Label || address.label;

                      let country = address.Country || address.country || address.countryCode;
                      devLog("Country:", country);

                      let twoLetterCode = country.length > 2 ? countryFind(country) : country;
                      devLog("Two Letter Code:", twoLetterCode);

                      DisablementInfo.GeoLocationStatus = "SUCCESS";
                      DisablementInfo.DisablementAddress = locationStreet;
                      DisablementInfo.DisablementStreet = locationStreet.split(",")[0]
                        ? locationStreet.split(",")[0]
                        : `${address.HouseNumber || address.houseNumber} ${address.Street || address.street}`;
                      DisablementInfo.DisablementCity = address.City || address.city;
                      DisablementInfo.DisablementState = address.StateCode || address.stateCode;
                      DisablementInfo.DisablementZip = address.PostalCode || address.postalCode;
                      DisablementInfo.DisablementCountry = twoLetterCode;
                    }
                  }
                } catch (e) {
                  console.error(e);
                }

                devLog("DisablementInfo: ", DisablementInfo, bHasDisablementCoords);
                const navigationService = appConfig?.isPortalUser
                  ? NavigationService.getService("PORTAL_USER")
                  : NavigationService.getService();
                appState = appConfig?.isPortalUser ? navigationService.defaultState : appState;
                devLog("portal appState:", appState);

                await this.setAsyncState({
                  navigationService: navigationService,
                  appConfig: appConfig,
                  clientApp: !!appConfig.clientApp,
                  towReasons: appConfig.towReasons,
                  isPortalUser: !!appConfig.isPortalUser,
                  accountRef: appConfig.accountRef,
                  contactRef: appConfig.contactRef,
                  contactName: appConfig.contactName,
                  autoSearchRequired: appConfig.autoSearchRequired,
                  skipMemberSearchLimit: this.state.skipMemberSearchLimit,
                  webAppState: appConfig?.clientApp && bCanCacheLastVistedView ? AppState.SelectService : appState,
                  DisablementCoords: disablementCoords,
                  GeoLocationStatus: DisablementInfo.GeoLocationStatus,
                  DisablementAddress: DisablementInfo.DisablementAddress,
                  DisablementStreet: DisablementInfo.DisablementStreet,
                  DisablementCity: DisablementInfo.DisablementCity,
                  DisablementState: DisablementInfo.DisablementState,
                  DisablementZip: DisablementInfo.DisablementZip,
                  DisablementCountry: DisablementInfo.DisablementCountry,
                });
              } else {
                console.warn("apiGetAppConfig: Failed to retrieve appConfig");
              }
            } catch (e) {
              console.error(e);
            }

            // check if an existing call is pending
            apiGetCallPending(this.state, (result) => {
              devLog("apiGetCallPending: Executed");
              // if we get a CallStatus === 24, call is cancelled
              devLog("1st Get Call pending:", result);

              if (typeof result !== "object") {
                console.error("result invalid Object type!");
                this.setState({ initialized: true });
              }

              this.setState({
                CallPendingParams: result,
              });

              try {
                if (!this.state.locale) {
                  this.setState({
                    locale: getCountryCode(),
                  });
                }
              } catch (e) {
                devLog("Failed to identify country code");
                console.error(e);
              }

              if (result.CallStatus && result.CallStatus === 24) {
                this.setState({
                  MessageTitle: "ConfirmCancel1",
                  Message: "ConfirmCancel2",
                  ShowMessage: true,
                  webAppState: AppState.Blank,
                  initialized: true,
                });
                return;
              }
              devLog("It is not canceled");

              // check if existing call is in progress
              apiGetCall(this.state, (responseParams) => {
                devLog("apiGetCall: Executed");
                // if response params are not null
                // process them
                devLog("responseParams", responseParams);

                if (!(typeof responseParams === "object") || responseParams == null) {
                  console.error("responseParams invalid Object type!");
                  // this.runCallCycler();
                  setTimeout(() => {
                    this.setState({ initialized: true });
                  }, 300);
                  return;
                }

                // first update the state with the data provided
                this.setState(responseParams, () => {
                  // a call is in progress but we don't know
                  // if it's in pending assignment or assigned/in progress
                  devLog("responseParams.RSAPCompanyName:", responseParams.RSAPCompanyName);
                  if (
                    responseParams.RSAPCompanyName !== null &&
                    responseParams.RSAPCompanyName !== undefined &&
                    responseParams.RSAPCompanyName !== ""
                  ) {
                    // a company is assigned so the provider is assigned/enroute
                    this.setState(
                      {
                        webAppState: AppState.ProviderEnroute,
                        // initialized: true,
                        CanRunCycler: true,
                      },
                      () => {
                        this.runCallCycler();
                        setTimeout(() => {
                          this.setState({
                            initialized: true,
                          });
                        }, 300);
                      },
                    );
                  } else {
                    // must be in a pending provider assignment state
                    this.setState(
                      {
                        webAppState: AppState.LocatingProvider,
                        // initialized: true,
                        CanRunCycler: true,
                      },
                      () => {
                        devLog("Trying to start Running getCallStatus");
                        this.runCallCycler();
                        setTimeout(() => {
                          this.setState({
                            initialized: true,
                          });
                        }, 300);
                      },
                    );
                  }
                });
              });
            });
          },
        );
      });
    });
  }

  checkInWithServerPartnerPromotion() {
    devLog("checkInWithServerPartnerPromotion: Executed");
    this.getAndSaveQueryParams(() => {
      setTimeout(() => {
        this.setState({
          webAppState: AppState.PartnerPromotion,
          initialized: true,
        });
      }, 1500);
    });
  }

  /**
   * checking in with server, in the event that the user is sent the feedback.html instead of the webapp.html
   *
   * @memberof WebAppView
   */
  checkInWithServerFeedback() {
    devLog("checkInWithServerFeedback: Executed");
    this.setState({ webAppState: AppState.Feedback });
    // grab query params and save to state
    this.getAndSaveQueryParams(() => {
      devLog("getAndSaveQueryParams: Executed");
      // loginCompany to get tokenid and guid
      apiLoginCompany(this.state, (companyParams) => {
        devLog("apiLoginCompany: Executed");
        devLog("response", companyParams.ProviderRef === null);
        this.setState({ currentCompanyParams: companyParams }, () => {
          // check if existing call is in progress
          apiGetCall(this.state, (getCallParams) => {
            devLog("apiGetCall: Executed");
            // if response params are not null process them
            devLog("response params on render", getCallParams);
            devLog(getCallParams !== null);
            if (getCallParams !== null) {
              if (getCallParams.CallParams && getCallParams.CallParams.encCallGUID) {
                getCallParams.encCallGUID = getCallParams.CallParams.encCallGUID;
              }

              devLog("getCallParams", getCallParams, companyParams);

              apiGetFeedbackStatus({
                data: {
                  providerRef: getCallParams.ProviderRef,
                },
                companyParams: {
                  encComGUID: companyParams.encComGUID,
                  GuidSecret: companyParams.GuidSecret,
                },
              })
                .then((res) => {
                  devLog("res", res);
                  const feedbackAppState = {
                    initialized: true,
                    CallStatusParams: getCallParams,
                    webAppState: AppState.Feedback,
                  };

                  const feedbackSubmitted = !!res?.data?.userSubmitted;

                  //Don't allow the user to submit again
                  if (feedbackSubmitted) {
                    feedbackAppState.ShowMessage = true;
                    feedbackAppState.MessageTitle = "Feedback1";
                    feedbackAppState.Message = "Feedback2";
                    feedbackAppState.webAppState = AppState.Blank;
                    feedbackAppState.MessageButtonTitle = "HelpCallButton2";
                  }

                  this.setState(feedbackAppState, () => {
                    devLog(
                      "Feedback Loaded:",
                      this.state.CallStatusParams.encCallGUID,
                      this.state.CallStatusParams.encComGUID,
                    );
                  });
                })
                .catch(() => {
                  this.setState({ initialized: true, CallStatusParams: getCallParams }, () => {
                    devLog(
                      "Feedback Loaded:",
                      this.state.CallStatusParams.encCallGUID,
                      this.state.CallStatusParams.encComGUID,
                    );
                  });
                });
            } else {
              this.setState({ initialized: true });
            }
          });
        });
      });
    });
  }

  /**
   * checking in with server, in the event that the user is sent the webapp-ttl.html instead of the webapp.html
   *
   * @memberof WebAppView
   */
  checkInWithServerTTL() {
    this.setState({ webAppState: AppState.TTLocateUser });
    // grab query params and save to state
    this.getAndSaveQueryParamsTTL(() => {
      // loginCompany to get tokenid and guid
      apiLoginCompany(this.state, (companyParams) => {
        devLog("response", companyParams.ProviderRef === null);
        this.setState({ currentCompanyParams: companyParams }, () => {
          // check if existing call is in progress
          apiGetCall(this.state, (getCallParams) => {
            // if response params are not null process them
            devLog("response params on render", getCallParams);
            devLog(getCallParams !== null);
            if (getCallParams !== null) {
              if (getCallParams.CallParams && getCallParams.CallParams.encCallGUID) {
                getCallParams.encCallGUID = getCallParams.CallParams.encCallGUID;
              }
              this.setState({ initialized: true, CallStatusParams: getCallParams }, () => {
                devLog("TTL Loaded:", this.state.CallStatusParams.encCallGUID, this.state.CallStatusParams.encComGUID);
              });
            } else {
              this.setState({ initialized: true });
            }
          });
        });
      });
    });
  }

  /**
   * function that collects the information from the state to create a service call to rapitow/salesforce
   * application will enter post dispatch after this step
   *
   * @memberof WebAppView
   */
  prepareAndCreateCall() {
    // setup the postdata we need to send to create call
    let callData = this.getPostDataForCall();

    devLog("PostData", callData);

    apiGetCallPending(this.state, (RespParams) => {
      devLog(RespParams);

      // Note: No longer timing out a call Instead we ignore this.
      // Check if there was an error or timeout
      // if (RespParams?.CallStatus === 34) {
      // 	//devLog("Error 34!!!");
      // 	this.setState({
      // 		ShowMessage: true,
      // 		MessageTitle: "ServiceCallStatusError1",
      // 		Message: "ServiceCallStatusError2",
      // 		webAppState: AppState.Blank,
      // 	});
      // 	return;
      // }

      // ----------
      // handle other failed cases
      // 31 == No providers identified
      // 30 == No Providers Eligible
      // 22 == Oerator cancelled
      if (
        RespParams?.CallStatus === 30 ||
        RespParams?.CallStatus === 31 ||
        RespParams?.CallStatus === 32 ||
        RespParams?.CallStatus === 37
      ) {
        // Send user 'you will get a call message'
        this.setState({
          MessageTitle: "ServiceCallStatusError1",
          Message: "ServiceCallStatusError3", //"ServiceCallStatusError2",
          ShowMessage: true,
          webAppState: this.state.webAppState,
        });
        return;
      }
      // ----------

      // no error so create the call
      apiCreateCall(this.state, callData, (callParams) => {
        //devLog("apiCallParams:", callParams);
        let callParamsJson = JSON.parse(callParams);
        devLog("apiCallParams:", callParamsJson);

        // save the response CallParams
        this.setState({ CallParams: callParamsJson }, () => {
          if (callParamsJson.Status === "ERR") {
            this.setState({
              webAppState: AppState.Blank,
              ShowMessage: true,
              MessageTitle: "ServiceCallStatusError1",
              Message:
                "Service call not submitted. A Customer Service Specialist will contact you shortly. \n\nError: " +
                callParamsJson.ErrorDesc,
            });
            return;
          } else {
            // all is well so start updating the new screen
            this.setState({ CanRunCycler: true }, () => {
              this.runCallCycler();
            });
          }
        });
      });
    });
  }

  /**
   * returns the propper country code based on the DisablementCountry
   * @returns
   * @memberof WebAppView
   */
  getCountryCode() {
    devLog("Chosen Country:", this.state.DisablementCountry);
    if (this.state.DisablementCountry === "CAN" || this.state.DisablementCountry === "Canada") {
      return "CA";
    } else if (this.state.DisablementCountry === "United States") {
      return "US";
    } else {
      return this.state.DisablementCountry;
    }
  }

  /**
   * could we abstract this, to clarify webAppView?
   *
   * @returns
   * @memberof WebAppView
   */
  getPostDataForCall() {
    devLog("getPostDataForCall state: ", this.state);
    const postData = {
      servicetype: this.state.Service || "",
      providerref: this.state.providerRef || "",
      vendorref: this.state.vendorRef || "",
      autoyear: this.state.Year || "",
      automake: this.state.Make || "",
      automodel: this.state.Model || "",
      autocolor: this.state.Color || "",
      odometer: this.state.Odometer || "",
      clientfirstname: this.state.FirstName || "",
      clientlastname: this.state.LastName || "",
      clientphone: this.state.Number || "",
      comment: this.state.ServiceDetails || "",
      platformtype: "Regular",
      lat: this.state.DisablementCoords.lat,
      lng: this.state.DisablementCoords.lng,
      laddr: this.state.DisablementAddress || "",
      lpark: this.state.Disablementlpark || "",
      lstreet: this.state.DisablementStreet || "",
      lcity: this.state.DisablementCity || "",
      lstate: this.state.DisablementState || "",
      lzip: this.state.DisablementZip || "",
      lcountry: this.getCountryCode(), //this.state.DisablementCountry || "",
      dlat: this.state.DestinationCoords.lat,
      dlng: this.state.DestinationCoords.lng,
      daddr: this.state.DestinationAddress || "",
      dcomp: this.state.DestinationCompany || "",
      dcompid: this.state.DestCompanyID || "",
      dstreet: this.state.DestinationStreet
        ? this.state.DestinationStreet.split(",")[0] || ""
        : this.state.DestinationAddress
          ? this.state.DestinationAddress?.split(",")[0] || ""
          : "",
      dcity: this.state.DestinationCity || "",
      dstate: this.state.DestinationState || "",
      dzip: this.state.DestinationZip || "",
      dcountry: this.state.DestinationCountry || "",
      dutygrade: this.state.DutyGrade,
      remainwithauto: this.state.WillRemainWithAuto || true,
      onhighway: this.state.OnHighway || "",
      FuelType: this.state.FuelType || "",
      towReason: this.state.towReason || "",

      usergroup: 1,

      scheduledEventDate: this.state.scheduledEventDate || "",
      additionalDetails: encodeURIComponent(JSON.stringify(this.state.additionalDetails)),
    };

    if (!!this.state.accountRef) {
      postData.accountRef = this.state.accountRef;
    }

    if (!!this.state.contactRef) {
      postData.contactRef = this.state.contactRef;
    }

    devLog("getPostDataForCall postData:", postData);
    return postData;
  }

  /**
   * function which calls the getCallStatus Function Loop which continuously makes calls to the back end for new information
   *
   * @memberof WebAppView
   */
  runCallCycler() {
    devLog("runCallCycler() -> Attempting to run.");
    if (this.state.CanRunCycler) {
      devLog("runCallCycler() -> Calling apiGetCallStatus");
      apiGetCallStatus(this.state, (RespCallStatusParams) => {
        devLog("-----> RespCallStatusParams.QuoteAmt", RespCallStatusParams.QuoteAmt);
        this.setState(
          {
            CallStatusParams: RespCallStatusParams,
            CallStatus: RespCallStatusParams.CallStatus,
          },
          () => {
            devLog("apiGetCallStatus:", RespCallStatusParams);
            // after saving CallStatusParams, process them
            this.processServerResponse();
          },
        );
      });

      setTimeout(() => {
        this.runCallCycler();
      }, REFRESH_DELAY);
    }
  }

  //reads response from runCallCycler and handles that information accordingly
  processServerResponse() {
    const CallStatusParams = this.state.CallStatusParams;
    if (!CallStatusParams) {
      console.error("Error: no CallStatusParams for processServerResponse()");
      return;
    }
    let operName,
      companyName,
      companyPhone,
      eta = "";
    devLog(companyName, companyPhone, eta);
    devLog("ProcName1:", CallStatusParams.ProcName);

    let procName = CallStatusParams.ProcName;

    /**
     * Override based on CallStatus
     */
    if (CallStatusParams.CallStatus == 2.0 || CallStatusParams.CallStatus == 36.0) {
      procName = "callstatus_callaccepted";
    } else if (CallStatusParams.CallStatus == 3.0) {
      procName = "callstatus_callenroute";
    } else if (CallStatusParams.CallStatus == 3.1) {
      procName = "callstatus_callenroute";
    } else if (CallStatusParams.CallStatus == 4.0) {
      procName = "callstatus_callarrived";
    } else if (CallStatusParams.CallStatus == 4.1) {
      procName = "callstatus_callenroutedest";
    } else if (CallStatusParams.CallStatus == 4.2) {
      procName = "callstatus_callenroutedest";
    } else if (CallStatusParams.CallStatus == 4.8) {
      procName = "callstatus_callarrivedtow";
    }

    devLog("ProcName2", procName);

    // process the ProcName param and update the webapp
    switch (procName) {
      case "callstatus_callpending":
        this.setState({ webAppState: AppState.LocatingProvider });
        break;
      case "callstatus_callautoaccept":
        this.setState({
          isAutoAccept: true,
          disableAutoAccept: true,
          webAppState: AppState.LocatingProvider,
        });
        break;
      case "callstatus_callpayreq":
        // take user to payment screen
        let quoteAmt = CallStatusParams.QuoteAmt;
        let quoteCurrency = CallStatusParams.Currency;
        this.setState({
          QuoteAmt: quoteAmt,
          QuoteCurrency: quoteCurrency,
          webAppState: AppState.PaymentRequired,
        });
        break;
      case "callstatus_callpaytimeout":
        // Show Something went wrong message when payment times out
        this.setState({
          MessageTitle: "ServiceCallStatusError1",
          Message: "ServiceCallStatusError2",
          ShowMessage: true,
          webAppState: AppState.Blank,
          CanRunCycler: false,
        });

        break;
      case "callstatus_callactive":
      case "callstatus_callenroute":
      case "callstatus_callaccepted":
      case "callstatus_callarrived":
        // update the user that provider arrived
        // 1 - set providername in state CallStatusParams.RSACompanyName.substring(0, 30)
        // 2 - set operator name: opername + ' ' + CallStatusParams.RSALastName; opername.substring(0, 30)
        // 3 - set operator phone #: CallStatusParams.RSAPhone
        // 4 - set ETA moment.utc(CallStatusParams.AcceptTime).local().add(CallStatusParams.DestTime, 's').format(OutTimeFormat)

        operName = `${CallStatusParams.RSAFirstName || ""}`;
        operName = operName + (operName.length > 0 ? " " : "") + `${CallStatusParams.RSALastName}`;
        let companyName = CallStatusParams.RSACompanyName.substring(0, 30);
        let companyPhone = CallStatusParams.RSAPhone;

        let eta = moment.utc(CallStatusParams.AcceptTime).local().add(CallStatusParams.RSATime, "s").format("h:mm a");

        devLog(eta);
        devLog("ETA: ", eta);
        devLog("Adding Seconds:", CallStatusParams.RSATime);
        devLog(`Accept time: ${CallStatusParams.AcceptTime} + ${CallStatusParams.RSATime} = ${eta}`);
        this.setState({
          EnRouteData: {
            time: eta,
            servProv: companyName,
            status:
              procName == "callstatus_callarrived"
                ? "Provider on scene at breakdown location"
                : procName == "callstatus_callenroute"
                  ? "Provider Enroute"
                  : "Provider Accepted",
          },
          OperatorName: operName,
          OperatorBusinessName: companyName,
          OperatorPhoneNumber: companyPhone,
          CallETA: eta,
          CallCoords: {
            lat: CallStatusParams.CallLat,
            lng: CallStatusParams.CallLng,
          },
          OperatorCoords: {
            lat: CallStatusParams.RSALat,
            lng: CallStatusParams.RSALng,
          },
          webAppState: AppState.ProviderEnroute,
        });

        // update the map if we can
        // if (this.state.mapObject && this.state.mapObject.hMap) {
        // 	removeAllMarker(this.state.mapObject);
        // 	// add users location
        // 	if (
        // 		CallStatusParams.RSALat !== 0 &&
        // 		CallStatusParams.RSALat !== 0 &&
        // 		this.state.firstEnrouteRender === true
        // 	) {
        // 		addMarkertoMapGroup(
        // 			this.state.mapObject,
        // 			{ lat: CallStatusParams.CallLat, lng: CallStatusParams.CallLng },
        // 			{ lat: CallStatusParams.RSALat, lng: CallStatusParams.RSALng },
        // 			TowMapMarker
        // 		);
        // 		this.setState({ firstEnrouteRender: false });
        // 	} else if (
        // 		CallStatusParams.RSALat !== 0 &&
        // 		CallStatusParams.RSALat !== 0 &&
        // 		this.state.firstEnrouteRender === false
        // 	) {
        // 		addMarkertoMapGroup(
        // 			this.state.mapObject,
        // 			{ lat: CallStatusParams.CallLat, lng: CallStatusParams.CallLng },
        // 			{ lat: CallStatusParams.RSALat, lng: CallStatusParams.RSALng },
        // 			TowMapMarker
        // 		);
        // 	} else {
        // 		addMarkertoMapGroupNoCenter(
        // 			this.state.mapObject,
        // 			{ lat: CallStatusParams.CallLat, lng: CallStatusParams.CallLng },
        // 			{ lat: 36.31725, lng: -82.35634 },
        // 			TowMapMarker
        // 		);
        // 	}
        // 	// addMarkertoMap(this.state.mapObject, {lat: CallStatusParams.CallLat, lng: CallStatusParams.CallLng});
        // 	// // add service provider
        // 	// addMarkertoMap(this.state.mapObject, {lat: CallStatusParams.RSALat, lng: CallStatusParams.RSALng}, TowMapMarker);
        // } else {
        // 	devLog("Map not available for marker changes");
        // }

        break;
      case "callstatus_callarrivedtow":
      case "callstatus_callenroutedest":
        try {
          // 1 - update the map to show tow truck and destination points
          //     setting state var ProviderEnRouteDest=true handles this.
          // 2 - add operator name to the dash view  (opername = CallStatusParams.RSAFirstName + lastname)
          // 3 - set destination time on dash view (moment.utc(CallStatusParams.AcceptTime).local().add(CallStatusParams.DestTime, 's').format(OutTimeFormat)

          // Sometimes, the map is not ready to be changed.
          //				if (!this.state.mapObject && !this.state.mapObject.hMap) {
          //					console.error("map not found");
          //					return;
          //				}

          devLog(CallStatusParams);
          operName = `${CallStatusParams.RSAFirstName || ""}`;
          operName = operName + (operName.length > 0 ? " " : "") + `${CallStatusParams.RSALastName}`;
          let companyName = CallStatusParams.RSACompanyName.substring(0, 30);
          let companyPhone = CallStatusParams.RSAPhone;
          let eta = moment
            .utc(CallStatusParams.ArrivedTime)
            .local()
            .add(CallStatusParams.DestTime, "s")
            .format("h:mm a");
          this.setState({
            EnRouteData: {
              time: eta,
              servProv: companyName,
              status:
                procName == "callstatus_callarrivedtow"
                  ? "Provider Arrived at tow-to destination"
                  : procName == "callstatus_callenroutedest"
                    ? "Provider Enroute to tow-to destination"
                    : "Provider Enroute to tow-to destination",
            },
            OperatorCoords: {
              lat: CallStatusParams.RSALat || CallStatusParams.CallLat,
              lng: CallStatusParams.RSALng || CallStatusParams.CallLng,
            },
            DestinationCoords: {
              lat: CallStatusParams.DestLat,
              lng: CallStatusParams.DestLng,
            },
            ProviderEnRouteDest: true,
            OperatorName: operName,
            OperatorBusinessName: companyName,
            OperatorPhoneNumber: companyPhone,
            CallETA: eta,
            webAppState: AppState.ProviderEnroute,
          });

          // update the map if we can
          if (this.state.mapObject && this.state.mapObject.hMap) {
            removeAllMarker(this.state.mapObject);
            // tow truck location
            addMarkertoMapGroup(
              this.state.mapObject,
              { lat: CallStatusParams.DestLat, lng: CallStatusParams.DestLng },
              { lat: CallStatusParams.RSALat, lng: CallStatusParams.RSALng },
              TowMapMarker,
              DestMapMarker,
            );
          } else {
            console.error("check for map not created");
          }
        } catch (e) {
          console.error(e);
        }
        break;
      case "callstatus_callcancel":
        break;
      case "callstatus_callcanceloper":
      case "callstatus_callarriveddest":
      case "callstatus_callcomplete":
      case "callstatus_callclosed":
        // Customer gone on arrival or Call cleared and sent back to Vendor or No eligible providers or No providers identified or Payment Required or Operator Cancelled
        // 31 == No providers identified
        // 30 == No Providers Eligible
        // 25 == TrxNow Case handled by Agent
        // 23 == Gone on arrival
        // 22 == Oerator cancelled
        if (
          CallStatusParams.CallStatus === 22 ||
          CallStatusParams.CallStatus === 23 ||
          CallStatusParams.CallStatus === 24 ||
          CallStatusParams.CallStatus === 25 ||
          CallStatusParams.CallStatus === 25.1 ||
          CallStatusParams.CallStatus === 25.2 ||
          CallStatusParams.CallStatus === 25.3 ||
          CallStatusParams.CallStatus === 25.4 ||
          CallStatusParams.CallStatus === 25.5 ||
          CallStatusParams.CallStatus === 25.6 ||
          CallStatusParams.CallStatus === 30 ||
          CallStatusParams.CallStatus === 31 ||
          CallStatusParams.CallStatus === 32 ||
          CallStatusParams.CallStatus === 37
        ) {
          if (CallStatusParams.CallStatus === 23) {
            // Show Gone on Arrival Message
            this.setState({
              MessageTitle: "GOA1",
              Message: "GOA2",
              ShowMessage: true,
              webAppState: AppState.Blank,
            });
          } else if (
            CallStatusParams.CallStatus === 30 ||
            CallStatusParams.CallStatus === 31 ||
            CallStatusParams.CallStatus === 32 ||
            CallStatusParams.CallStatus === 37
          ) {
            // Send user 'you will get a call message'
            this.setState({
              MessageTitle: "ServiceCallStatusError1",
              Message: "ServiceCallStatusError3", //"ServiceCallStatusError2",
              ShowMessage: true,
              webAppState: this.state.webAppState,
              // webAppState: AppState.Blank,
            });
          } else if (
            CallStatusParams.CallStatus === 25 ||
            CallStatusParams.CallStatus === 25.1 ||
            CallStatusParams.CallStatus === 25.2 ||
            CallStatusParams.CallStatus === 25.3 ||
            CallStatusParams.CallStatus === 25.4 ||
            CallStatusParams.CallStatus === 25.5 ||
            CallStatusParams.CallStatus === 25.6 ||
            CallStatusParams.CallStatus === 1.5 ||
            CallStatusParams.CallStatus === 1.6
          ) {
            // do not react to a 25
          } else if (CallStatusParams.CallStatus === 24) {
            this.setState({
              MessageTitle: "ConfirmCancel1",
              Message: "ConfirmCancel2",
              ShowMessage: true,
              webAppState: AppState.Blank,
            });
          } else {
            this.setState({
              MessageTitle: "ServiceCallStatusError1",
              Message: "ServiceCallStatusError2",
              ShowMessage: true,
              webAppState: AppState.Blank,
            });
          }
        } else {
          // stop processing the API calls (its all over!)
          // then go to Feedback view
          if (CallStatusParams.CallStatus === 5.0) {
            this.setState({
              MessageTitle: "ConfirmCancel1",
              Message: "ConfirmCancel2",
              ShowMessage: true,
              webAppState: AppState.Blank,
            });
          } else {
            this.setState({
              ShouldProcessAPI: false,
              CanRunCycler: false,
              webAppState: AppState.Feedback,
            });
          }
        }
        break;
      default:
        break;
    }

    // show current status of the driver (currently 'on the way' or 'arrived')
    if (CallStatusParams.CallStatus === 4.0 || CallStatusParams.CallStatus === 4.1) {
      this.setState({ CallStatusMessage: "arrived" });
    } else {
      this.setState({ CallStatusMessage: "on the way" });
    }
  }

  /**
   * These functions are callbacks from each of
   *  the major views. We retrieve their data and store
   *  it in the WebAppView state for future processing.
   *  (i.e. get cust info, store it and move on, etc.)
   *
   * @memberof WebAppView
   */
  setWebAppState(data) {
    this.setState({
      ...this.state,
      ...data,
    });
  }

  /**
   * handles calling out to the remote service to cancel the pending roadside request
   *
   * @memberof WebAppView
   */
  handleCancelCall = () => {
    devLog("Cancelling the call!");
    // user confirmed they want to cancel the call — close dialog and show full-screen pending spinner until API returns
    this.setState(
      {
        ShowMessage: false,
        cancelCallPendingLoading: true,
      },
      () => {
        if (this.state.deflectionCancel) {
          try {
            apiSetDeflected({
              data: {
                providerRef: this.state.providerRef,
                memberInfo: this.state.deflectionInfo.contractData,
                vehicle: this.state.deflectionInfo.selectedVehicle,
                odometer: this.state.deflectionInfo.odometer,
              },
              companyParams: this.state.currentCompanyParams,
            });
          } catch (e) {
            console.error(e);
          }
        }
        apiCancelCallPending(this.state, (response) => {
          devLog("confirmCancel response:", response);

          if (response == null) {
            this.setState({
              cancelCallPendingLoading: false,
              ShowMessage: true,
              MessageTitle: "GeoLocateErrorTitle",
              Message: "GeoLocateErrorMessage",
              MessageSecondAction: null,
              MessageSecondButtonTitle: null,
              MessageButtonTitle: "OK",
              MessagePreventDismiss: false,
              MessageHidePrimaryButton: false,
            });
            return;
          }

          // call was cancelled so take them to final cancel screen
          this.setState({
            cancelCallPendingLoading: false,
            ShowMessage: true,
            MessageTitle: "ConfirmCancel1",
            Message: "ConfirmCancel2",
            MessageSecondAction: null,
            MessageSecondButtonTitle: null,
            MessageButtonTitle: "OK",
            MessagePreventDismiss: false,
            MessageHidePrimaryButton: false,

            webAppState: AppState.Blank,
            deflectionCancel: false,
            deflectionInfo: undefined,
          });
        });
      },
    );
  };

  /**
   * handle cancel button
   * this will show the Confirm Cancel modal
   * the positive action will call `handleCancelCall()` to execute a cancel request
   *
   * @memberof WebAppView
   */
  cancelPendingCallCallback = (params) => {
    devLog("Cancel call callback called");
    this.setState({
      deflectionCancel: params?.deflection === true,
      deflectionInfo: params?.deflectionInfo,
      ShowMessage: true,
      MessageTitle: "CancelCall1",
      Message: "CancelCall2",
      MessageButtonTitle: "No",
      MessageSecondButtonTitle: "Yes",
      MessageSecondAction: this.handleCancelCall,
      MessagePreventDismiss: false,
      MessageHidePrimaryButton: false,
    });
  };

  /**
   * handles calling out to the remote service to cancel the roadside request
   *
   * @memberof WebAppView
   */
  confirmCancel = () => {
    devLog("Confirm cancelled called");
    // user confirmed they want to cancel the call
    this.setState({
      ShowMessage: false,
    });
    apiCancelCall(this.state, (response) => {
      devLog("confirmCancel response:", response);

      // call was cancelled so take them to final cancel screen
      this.setState({
        webAppState: AppState.Blank,
        ShowMessage: true,
        MessageTitle: "ConfirmCancel1",
        Message: "ConfirmCancel2",
        MessageSecondAction: null,
        MessageSecondButtonTitle: null,
        MessageButtonTitle: "OK",
        MessagePreventDismiss: false,
        MessageHidePrimaryButton: false,
      });
    });
  };

  /**
   * handle cancel button
   * this will show the Confirm Cancel modal
   * the positive action will call `confirmCancel()` to execute a cancel request
   *
   * @memberof WebAppView
   */
  cancelCallReqCallback = () => {
    this.setState({
      ShowMessage: true,
      MessageTitle: "CancelCall1",
      Message: "CancelCall2",
      MessageSecondAction: this.confirmCancel,
      MessageSecondButtonTitle: "Yes",
      MessageButtonTitle: "No",
      MessagePreventDismiss: false,
      MessageHidePrimaryButton: false,
    });
  };

  disableCancelCallReqCallback = () => {
    this.setState({
      ShowMessage: true,
      MessageTitle: "DisableCancelCall",
      Message: "CancelCall4",
      MessageSecondAction: this.confirmCancel,
      MessageButtonTitle: "CancelCallButton4",
      MessagePreventDismiss: false,
      MessageHidePrimaryButton: false,
    });
  };

  /**
   * handles the user location callback to store the updated disablement information of the current user
   * this updated information will be saved to the Component state.
   * @param {*} coords
   * @param {*} locationData
   * @memberof WebAppView
   */

  updateUserLocationCallback = (coords, addressList) => {
    devLog("updateUserLocationCallback addressList: ", addressList);
    let country = undefined;
    let streetNum = undefined;
    let street = undefined;
    let locationStreet = undefined;
    let state = undefined;
    let city = undefined;
    let postalCode = undefined;
    let addressComponents = addressList.address_components;
    let fullAddress = addressList.formatted_address;

    for (let i = 0; i < addressComponents.length; i++) {
      let comp = addressComponents[i];
      if (comp.types.indexOf("street_number") >= 0) {
        streetNum = comp.short_name.trim();
      } else if (comp.types.indexOf("route") >= 0) {
        street = comp.short_name.trim();
      } else if (comp.types.indexOf("intersection") >= 0) {
        street = comp.short_name.trim();
      } else if (comp.types.indexOf("plus_code") >= 0) {
        street = comp.short_name.trim();
      } else if (
        comp.types.indexOf("locality") >= 0 ||
        comp.types.indexOf("neighborhood") >= 0 ||
        comp.types.indexOf("administrative_area_level_3") >= 0
      ) {
        city = comp.long_name.trim();
      } else if (comp.types.indexOf("postal_code") >= 0) {
        postalCode = comp.long_name.trim();
      } else if (comp.types.indexOf("administrative_area_level_1") >= 0) {
        state = comp.short_name.trim();
      } else if (comp.types.indexOf("country") >= 0 || comp.types.indexOf("political") >= 0) {
        country = comp.short_name.trim();
      }
    }

    locationStreet = streetNum && street ? streetNum + " " + street : street;

    if (country && locationStreet && state && city && postalCode && fullAddress) {
      this.setState(
        {
          DisablementAddress: fullAddress,
          DisablementCoords: {
            lat: coords.lat,
            lng: coords.lng,
          },
          DisablementStreet: locationStreet,
          DisablementCity: city,
          DisablementState: state,
          DisablementZip: postalCode,
          DisablementCountry: country,
        },
        () => {},
      );
    }
  };

  // updateUserLocationCallback = (coords, locationData) => {
  //   let country =
  //     locationData.Country ||
  //     locationData.country ||
  //     locationData.address.countryCode;
  //   devLog("Country:", country);
  //   let twoLetterCode = country.length > 2 ? countryFind(country) : country;
  //   devLog("Two Letter Code:", twoLetterCode);
  //   devLog("address country code:", locationData.address.countryCode);

  //   // Note because we keep switching back and forth between here.com and google
  //   // we are using both syntaxes so we don't have to update in the future
  //   // we can simplify if we do finally pick one path
  //   // let locationStreet = locationData.Label || locationData.title;
  //   let locationStreet = (
  //     (locationData?.address?.houseNumber
  //       ? locationData?.address?.houseNumber
  //       : "") +
  //     " " +
  //     (locationData?.address?.street ? locationData?.address?.street : "")
  //   ).trim();

  //   this.setState(
  //     {
  //       DisablementAddress: locationData.Label || locationData.title,
  //       DisablementCoords: {
  //         lat: coords.lat,
  //         lng: coords.lng,
  //       },
  //       DisablementStreet: locationStreet /*.split(",")[0]
  //         ? locationStreet.split(",")[0]
  //         : `${locationData.HouseNumber || locationData.address.houseNumber} ${
  //             locationData.Street || locationData.address.street
  //           }`*/,
  //       DisablementCity:
  //         locationData.City || locationData.city || locationData.address.city,
  //       DisablementState:
  //         locationData.State ||
  //         locationData.state ||
  //         locationData.address.stateCode ||
  //         locationData.address.state,
  //       DisablementZip:
  //         locationData.PostalCode ||
  //         locationData.postalCode ||
  //         locationData.address.postalCode,
  //       DisablementCountry: twoLetterCode,
  //     },
  //     () => {
  //       devLog("1AddressData", locationData);
  //       devLog("1State", this.state.DisablementState);
  //       devLog("1Street:", this.state.DisablementStreet);
  //     }
  //   );
  // };

  /**
   * handle Next button callback
   * updates the application state to navigate the user to the next screen
   * @param {*} data
   * @returns void
   * @memberof WebAppView
   */
  locateUserCallback = (data) => {
    const naviState = this.state.navigationService.getState(AppState.LocateUser);
    if (!this.state.DisablementAddress || this.state.DisablementAddress.length < 1) {
      this.setState({
        MessageTitle: "GeoLocateErrorTitle",
        Message: "GeoLocateErrorMessage",
        MessageButtonTitle: "Ok",
        ShowMessage: true,
      });
      return;
    }

    if (data.onHighway === undefined || data.onHighway === "") {
      this.setState({
        MessageTitle: "OnHighwayErrorTitle",
        Message: "OnHighwayErrorMessage",
        // MessageButtonTitle: "Ok",
        ShowMessage: true,
      });
      return;
    }

    if (data.onHighway === undefined || !data.addressSelected) {
      this.setState({
        MessageTitle: "AddressSelectionErrorTitle",
        Message: "AddressSelectionErrorMessage",
        // MessageButtonTitle: "Ok",
        ShowMessage: true,
      });
      return;
    }

    this.setState(
      {
        webAppState: this.state.ReturnToConfirm
          ? AppState.ConfirmInformation
          : naviState && typeof naviState.nextState !== "undefined"
            ? naviState.getNextState(this.state)
            : AppState.ConfirmCustomer,
        ReturnToConfirm: false,
        OnHighway: data.onHighway.value === "true" ? true : false,
      },
      () => {
        this.saveWebAppState(this);
        apiSetSubmitStage(this.state, 2, this.state.DisablementAddress || "DisablementAddress Not Available");
      },
    );
  };

  // original callback
  // locateUserCallback = (data) => {
  // 	var twoLetterCode = data.address.countryCode.length > 2 ? countryFind(data.address.countryCode) : data.address.countryCode;

  // 	this.setState(
  // 		{
  // 			// TODO: utilize disablement object in state with data
  // 			DisablementCoords: data.position || {},
  // 			DisablementObject: data,
  // 			DisablementAddress: data.title || {},
  // 			DisablementStreet:
  // 				(data.address.houseNumber || "") + " " + data.address.street,
  // 			DisablementCity: data.address.city,
  // 			DisablementState: data.address.stateCode,
  // 			DisablementZip: data.address.postalCode,
  // 			DisablementCountry: twoLetterCode,
  // 			webAppState: this.state.ReturnToConfirm ? AppState.ConfirmInformation : AppState.ConfirmCustomer,
  // 			ReturnToConfirm: false
  // 		},
  // 		() => {
  // 			apiSetSubmitStage(
  // 				this.state,
  // 				2,
  // 				this.state.DisablementAddress || "DisablementAddress Not Available"
  // 			);
  // 		}
  // 	);
  // };

  /**
   *
   * @memberof WebAppView
   */
  ttLocateUserCallback = () => {
    devLog(this.state.DisablementAddress);
  };

  /**
   * handle Next button callback
   * updates the application state to navigate the user to the next screen
   * @param {*} data
   * @returns void
   * @memberof WebAppView
   */
  onConfirmCustomerNext = (data) => {
    // context={this}
    const naviState = this.state.navigationService.getState(AppState.ConfirmCustomer);

    const naviStateMemberSearch = this.state.navigationService.getState(AppState.MemberSearch);
    const naviStateConfirmVehicle = this.state.navigationService.getState(AppState.ConfirmVehicle);

    const nextState =
      naviStateMemberSearch && typeof naviStateMemberSearch.nextState === "number"
        ? naviStateMemberSearch.nextState
        : AppState.ConfirmVehicle;

    const naviStateConfirmVehicleNext =
      naviStateConfirmVehicle && typeof naviStateConfirmVehicle.nextState === "number"
        ? naviStateConfirmVehicle.nextState
        : AppState.SelectService;

    /**
     * Skip the member search page when the case has ContactId and AccountId
     * And if it is the BWC case, it will still do the AUTO_SEARCH
     */
    if (this.state.localGroup === "PBFL") {
      devLog("PBFL nextState ");
      this.setState(
        {
          webAppState: AppState.ConfirmVehicle,
          FirstName: data.FirstName,
          LastName: data.LastName,
          Number: data.Number,
          MemberLookup: {
            firstName: data.FirstName,
            lastName: data.LastName,
            phoneNumber: data.Number,
            partnerCode: "PBFL",
            companyName: data.companyName,
            country: data.country,
            driverNumber: data.driverNumber,
          },
        },
        () => {
          apiSetSubmitStage(
            this.state,
            naviStateConfirmVehicleNext,
            this.state.DisablementAddress || "DisablementAddress Not Available",
          );
          this.saveWebAppState(this);
        },
      );
    } else if (
      this.state.skipMemberSearchLimit === 0 &&
      this.state.autoSearchRequired === true &&
      this.state.contactRef &&
      this.state.accountRef &&
      this.state.localGroup === "ATT"
    ) {
      this.setState(
        {
          webAppState: nextState,
          FirstName: data.FirstName,
          LastName: data.LastName,
          Number: data.Number,
          MemberLookup: {
            contactRef: this.state.contactRef,
            accountRef: this.state.accountRef,
            contactName: this.state.contactName,
            searchType: "AUTO_SEARCH",
          },
        },
        () => {
          apiSetSubmitStage(this.state, nextState, this.state.DisablementAddress || "DisablementAddress Not Available");
          this.saveWebAppState(this);
        },
      );
    } else if (this.state.localGroup === "BWC") {
      this.setState(
        {
          webAppState: nextState,
          FirstName: data.FirstName,
          LastName: data.LastName,
          Number: data.Number,
          MemberLookup: {
            firstName: data.FirstName,
            lastName: data.LastName,
            // phoneNumber: data.Number,
            searchType: "AUTO_SEARCH",
          },
        },
        () => {
          apiSetSubmitStage(this.state, nextState, this.state.DisablementAddress || "DisablementAddress Not Available");
          this.saveWebAppState(this);
        },
      );
    } else {
      this.setState(
        {
          MemberLookup: {
            firstName: data.FirstName,
            lastName: data.LastName,
            phoneNumber: data.Number,
          },
          FirstName: data.FirstName,
          LastName: data.LastName,
          Number: data.Number,
          PolicyNumber: data.PolicyNumber,
          webAppState:
            naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle, // go to confirm vechicle info
        },
        () => {
          // after saving customer info:
          apiSetSubmitStage(this.state, 2, this.state.DisablementAddress || "DisablementAddress Not Available");
          this.saveWebAppState(this);
        },
      );
    }
  };

  /**
   * handle Next button callback
   * updates the application state to navigate the user to the next screen
   * @param {*} data
   * @returns void
   * @memberof WebAppView
   */
  confirmVehicleCallBack = (data) => {
    const naviState = this.state.navigationService.getState(AppState.ConfirmVehicle);
    this.setState(
      {
        Year: data.Year,
        Make: data.Make,
        Model: data.Model,
        Color: data.Color,
        Weight: data.Weight,
        webAppState:
          naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.SelectService,
      },
      () => {
        this.saveWebAppState(this);
        // after saving vehicle info:
        var autoInfo = `${this.state.Year || "no year"} ${this.state.Make || "no make"} ${
          this.state.Model || "no model"
        }`;
        apiSetSubmitStage(this.state, 3, autoInfo);
      },
    );
  };

  /**
   *
   * @param {*} data
   * @returns boolean
   * @memberof WebAppView
   */
  checkIfAutoAccept = (data) => {
    if (data.serviceType.toUpperCase() !== "TOW") {
      return true;
    } else {
      return false;
    }
  };

  /**
   * handle Next button callback
   * updates the application state to navigate the user to the next screen
   * @param {*} data
   * @returns void
   * @memberof WebAppView
   */
  confirmServiceCallBack = (data) => {
    /*this.setState(
			{
				Service: data.serviceType,
				isAutoAccept: this.checkIfAutoAccept(data),
				FuelType: data.fuelType,
				webAppState:
					`${data.serviceType}`.toUpperCase() === "TOW"
						? AppState.SelectDestination
						: AppState.ConfirmInformation,
			},
			() => {
				// after user selects their service:
				apiSetSubmitStage(
					this.state,
					4,
					this.state.Service || "Service Type Not Available"
				);
			}
		);*/
    // after user selects their service:
    apiSetSubmitStage(this.state, 4, this.state.Service || "Service Type Not Available");
    this.saveWebAppState(this);
  };

  /**
   * handle Next button callback
   * updates the application state to navigate the user to the next screen
   * @param {*} data
   * @returns void
   * @memberof WebAppView
   */
  confirmDestinationCallBack = (data, nrfData, options) => {
    devLog("confirmDestinationCallback data:", data);
    devLog("confirmDestinationCallback nrfData:", nrfData);
    const naviState = this.state.navigationService.getState(AppState.SelectDestination);
    var twoLetterCode = countryFind(data.address.countryCode);
    this.setState(
      {
        DestinationObj: data,
        // I need the data below for API calls
        DestinationAddress: data.address.label,
        DestinationCompany: data.title,
        DestinationStreet:
          // data.address.parkName +
          // ", " +
          data.address.houseNumber + " " + data.address.street,
        DestinationCity: data.address.city,
        DestinationState: data.address.stateCode,
        DestinationZip: data.address.postalCode,
        DestinationCountry: twoLetterCode,
        DestinationCoords: data.position,
        DestCompanyID: nrfData?.DestCompanyID,
        webAppState:
          naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmInformation,
        // goto confirm information view
        ReturnToConfirm: false,
        towDistance: nrfData?.distance,
        towDistanceUnit: nrfData?.distanceUnit,
        towPrice: options?.towPrice,
      },
      () => {
        this.saveWebAppState(this);
        apiSetSubmitStage(this.state, 5, this.state.DestinationAddress || "DestAddress Not Available");
      },
    );
  };

  /**
   * handle Next button callback
   * updates the application state to navigate the user to the next screen
   * @param {*} data
   * @returns void
   * @memberof WebAppView
   */
  confirmInformationCallback = async (data) => {
    devLog("confirmInformationCallback this.state: ", this.state);
    if (this.state.webAppState === AppState.ConfirmInformation) {
      devLog("ConfirmInformation data: ", data);
      await this.setAsyncState({
        WillRemainWithAuto: data.WillRemainWithAuto,
        OnHighway: data.OnHighway,
        ServiceDetails: data.ServiceDetails,
        webAppState: AppState.LocatingProvider,
      });
      apiSetSubmitStage(this.state, 6, "Locating Provider");
      this.prepareAndCreateCall();
      this.saveWebAppState(this);
      try {
        window.localStorage?.removeItem("appState");
        window.localStorage?.removeItem("webAppState");
        window.localStorage?.removeItem("providerRef");
      } catch (e) {
        console.error(e);
      }
    } else if (this.state.webAppState === AppState.MemberSearch) {
      await this.setAsyncState({
        webAppState: AppState.MemberInformation,
      });
      apiSetSubmitStage(this.state, 211, "Policy Information");
      this.prepareAndCreateCall();
      this.saveWebAppState(this);
    } else if (this.state.webAppState === AppState.MemberInformation) {
      await this.setAsyncState({
        webAppState: AppState.ConfirmVehicle,
      });
      apiSetSubmitStage(this.state, 201, "Confirm Vehicle");
      this.prepareAndCreateCall();
      this.saveWebAppState(this);
    }
  };

  /**
   *
   * @memberof WebAppView
   */
  resetFlag = () => {
    this.setState({
      ConfirmInfoFlag: false,
    });
  };

  /**
   * handles if the user denied geolocation services on their phone, and choose to attempt to locate themselves with the web application
   *
   * @param {*} data
   * @memberof WebAppView
   */
  userDeniedLocation = (data) => {
    if (this.state.webAppState === AppState.LocateUser) {
      this.setState({
        GeoLocationStatus: "ERROR",
        userDeniedLocation: true,
      });
      // alert(this.props.t("description.DeniedLocationTest"));
    } else {
      this.setState({
        GeoLocationStatus: "ERROR",
        userDeniedLocation: true,
      });
      devLog("User rejected geolocation permission");
    }

    if (hotjar) {
      hotjar.event("rejected geolocation permission");
    }
  };

  // /**
  //  *
  //  * @param {*} data
  //  * @memberof WebAppView
  //  */
  // confirmInfoDisabCallBack = (data) => {
  // 	this.setState({
  // 		webAppState: data,
  // 		ConfirmInfoFlag: !this.state.ConfirmInfoFlag,
  // 		ReturnToConfirm: true
  // 	});
  // };

  // /**
  //  *
  //  * @param {*} data
  //  * @memberof WebAppView
  //  */
  // confirmInfoDestCallBack = (data) => {
  // 	this.setState({
  // 		webAppState: data,
  // 		ConfirmInfoFlag: !this.state.ConfirmInfoFlag,
  // 		ReturnToConfirm: true
  // 	});
  // };

  /**
   * handle enroute update callback
   * updates the application state with the passed map data
   * @param {*} data
   * @returns void
   * @memberof WebAppView
   */
  enRouteCallback = (data) => {
    this.setState({
      mapObject: {
        H: data.H,
        hMap: data.hMap,
      },
    });
  };

  /**
   * handle help button from Enroute screen
   * @memberof WebAppView
   */
  enRouteHelpButtonPressed = () => {
    this.setState({ ShowHelp: true });
  };

  /**
   * open a new window to trigger the phone panel of the users mobile device
   * @memberof WebAppView
   */
  callProvider() {
    window.open("tel:" + this.state.CallStatusParams.RSAAcceptCompanyPhone);
  }

  /**
   * open a new window to trigger the phone panel of the users mobile device
   * it is used on the enroute page when the user clicks the cancel button
   * @memberof WebAppView
   */
  callCallBackNumber() {
    const CALLBACK_NUMBER = process.env.REACT_APP_CALLBACK_NUMBER || "1-855-203-1423"; //SB: 1-512-580-8282
    window.open("tel:" + CALLBACK_NUMBER);
  }

  /**
   * return the phone number of the assigned provider
   * @returns
   * @memberof WebAppView
   */
  getProviderPhone() {
    const phone = this.state.OperatorPhoneNumber;

    if (phone !== null && phone !== undefined && phone !== "") {
      return phone;
    } else {
      return null;
    }
  }

  /**
   * handle feedback Next button callback
   * @param {*} data
   * @memberof WebAppView
   */
  feedbackConfirmedCallback = (data) => {
    // TODO: Call API to save feedback data
    devLog("feedbackConfirmedCallback", data);
    //devLog("Recommendation: " + data.comment1 + " --Service Provider: " + data.comment2 + " --Service Quality: " + data.comment3)
    if ((this.state.partner === "FIMC" || this.state.localGroup === "FIMC") && data.recommendation === 5) {
      //https://g.page/r/CfXZ5_XkLg58EBM/review
      this.setState(
        {
          ShowMessage: true,
          MessageTitle: "Feedback1",
          Message: "Feedback3",
          webAppState: AppState.Blank,
          ServiceDetails: data.comment1,
          MessageSecondButtonTitle: undefined, //"HelpCallButton2",
          MessageSecondAction: undefined /*() => {
            devLog("Second Button");
          },*/,
          MessageButtonTitle: "HelpCallButton3",
          // MessageButtonClass: "btn-learn-more", //
          onUserModalConfirm: () => {
            devLog("First Button (Learn More!!!)");
            window.location.href = "https://g.page/r/CfXZ5_XkLg58EBM/review";
          },
          recommendation: data.recommendation,
        },
        () => {
          devLog("Calling submit feedback");
          apiFeedbackSubmit(this.state, data, (result) => {
            devLog("Feedback Result:", result);
          });
        },
      );
    } else {
      this.setState(
        {
          ShowMessage: true,
          MessageTitle: "Feedback1",
          Message: "Feedback2",
          webAppState: AppState.Blank,
          ServiceDetails: data.comment1,
          MessageButtonTitle: "HelpCallButton2",
          // MessageButtonClass: "",
          recommendation: data.recommendation,
        },
        () => {
          devLog("Calling submit feedback");
          apiFeedbackSubmit(this.state, data, (result) => {
            devLog("Feedback Result:", result);
          });
        },
      );
    }
  };

  /**
   * call back function that gives functionality to the edit buttons on Confirm Information
   * and left pointing carats found in the header component on the form items.
   *
   * this is a generic function that is used by numerous screens
   * @returns
   * @memberof WebAppView
   */
  onUserBackClicked = () => {
    let prevState = AppState.LocateUser;

    //attempt to use the new navigation service to determine the previous screen
    const naviState = this.state.navigationService.getState(this.state.webAppState);
    // if (
    //   naviState &&
    //   this.state.webAppState === 2 &&
    //   typeof naviState.previousState !== "undefined" &&
    //   this.state.localGroup === "BMO"
    // ) {
    //   devLog("BMO userback");
    //   this.setState(
    //     {
    //       webAppState: AppState.MemberSearch,
    //     },
    //     () => {
    //       this.saveWebAppState(this);
    //     }
    //   );
    //   return;
    // } else

    /**
     * When the user does the auto search and hit back button from the vehicle page,
     * it will go back to member search page.
     * If the user is not in the auto search, it will go back to member information page (previous page)
     */
    devLog("PeeviousState:", naviState?.getPreviousState(this.state));
    if (this.state.localGroup === "PBFL" && naviState && naviState?.getPreviousState(this.state) === 201) {
      this.setState({ webAppState: 1 }, () => {
        this.saveWebAppState(this);
      });
      return;
    } else if (
      naviState &&
      //MemberInformation
      naviState?.getPreviousState(this.state) === 201 &&
      this.state.autoSearchRequired === true &&
      this.state.skipMemberSearchLimit !== 2
    ) {
      this.setState({ webAppState: 211 }, () => {
        this.saveWebAppState(this);
      });
      return;
    } else if (naviState && typeof naviState.previousState !== "undefined") {
      this.setState({ webAppState: naviState.getPreviousState(this.state) }, () => {
        this.saveWebAppState(this);
      });
      return;
    }

    //fallback to the original selection process
    switch (this.state.webAppState) {
      case AppState.ConfirmInformation:
        prevState = AppState.SelectService;
        break;
      case AppState.SelectService:
        prevState = AppState.ConfirmVehicle;
        break;
      case AppState.ConfirmVehicle:
        prevState = AppState.ConfirmCustomer;
        break;
      case AppState.SelectDestination:
        prevState = AppState.SelectService;
        break;
      case AppState.ConfirmCustomer:
        prevState = AppState.LocateUser;
        break;
      default:
        break;
    }
    this.setState({ webAppState: prevState }, () => {
      this.saveWebAppState(this);
    });
  };

  /**
   * handle back button and set the webAppState
   * @param {*} state
   * @memberof WebAppView
   */
  backButtonPressedFromConfirmInfo = (state) => {
    this.setState({ webAppState: state });
  };

  // LocateUser: 0,
  // ConfirmCustomer: 1,
  // ConfirmVehicle: 2,
  // SelectService:3,
  // SelectDestination: 4,
  // LocatingProvider: 5,
  // ConfirmInformation: 6,
  // PaymentRequired: 7,
  // ProviderEnroute: 8,
  // Feedback: 9,
  // Temp: 10,
  // Blank: -1

  /**
   * getAndSaveQueryParams()
   * This function gets the query params and
   * saves them to the this.state object for
   * future use. This should be called on load
   * @param {*} callback
   * @memberof WebAppView
   */
  getAndSaveQueryParams(callback) {
    const urlParams = this.parseUrlParams();
    devLog(urlParams);
    this.setState(
      {
        tokenID: urlParams["tokenid"] || "",
        providerRef: urlParams["providerref"] || "",
        vendorRef: urlParams["vendorref"] || "",
        FirstName: urlParams["firstname"] || "",
        LastName: urlParams["lastname"] || "",
        Number: urlParams["phone"] || "",
        Service: urlParams["servicetype"] || "",
        Year: urlParams["vehicleyear"] || "",
        Make: urlParams["vehiclemake"] || "",
        Model: urlParams["vehiclemodel"] || "",
        Color: urlParams["vehiclecolor"] || "",
        Weight: urlParams["vehicledutygrade"] || "",
        DutyGrade: urlParams["vehicledutygrade"] || "",
        localGroup: urlParams["lg"] || "",
        lang: urlParams["lang"] || "",
        cid: urlParams["cid"] || "",
        ShowDebugControls: urlParams["debugmode"] || false,
        MemberLookup: {
          firstName: urlParams["firstname"] || "",
          lastName: urlParams["lastname"] || "",
          phoneNumber: urlParams["phone"] || "",
        },
      },
      () => {
        if (hotjar && urlParams["vendorref"]) {
          var poNum = `${urlParams["vendorref"]}`;
          poNum = poNum.replace("000", "");
          if (window.location.href.includes("sandbox")) {
            poNum = poNum + "S";
          }
          hotjar.identify("user_id", { userProperty: poNum });
        }

        // TODO: set language property
        // init language with this.state.lang

        if (callback) {
          callback();
        }
      },
    );
  }

  /**
   * getAndSaveQueryParams()
   * This function gets the query params and
   * saves them to the this.state object for
   * future use. This should be called on load
   * @param {*} callback
   * @memberof WebAppView
   */
  getAndSaveQueryParamsTTL(callback) {
    const urlParams = this.parseUrlParams();
    devLog(urlParams);
    this.setState(
      {
        tokenID: "EPjL4_rudfNCzXQOrc72U-5lKT27WeStBEmsyOSihcXgRMxdLpKO9xWmdSk1weF7nQ",
        idno: urlParams["idno"] || "",
        providerRef: urlParams["ref"] || "",
        vendorRef: urlParams["vendorref"] || "",
        FirstName: urlParams["firstname"] || "",
        LastName: urlParams["lastname"] || "",
        Number: urlParams["phone"] || "",
        Service: urlParams["servicetype"] || "",
        Year: urlParams["vehicleyear"] || "",
        Make: urlParams["vehiclemake"] || "",
        Model: urlParams["vehiclemodel"] || "",
        Color: urlParams["vehiclecolor"] || "",
        localGroup: urlParams["lg"] || "",
        lang: urlParams["lang"] || "",
        ShowDebugControls: urlParams["debugmode"] || false,
      },
      () => {
        if (hotjar && urlParams["vendorref"]) {
          var poNum = `${urlParams["vendorref"]}`;
          poNum = poNum.replace("000", "");
          if (window.location.href.includes("sandbox")) {
            poNum = poNum + "S";
          }
          hotjar.identify("user_id", { userProperty: poNum });
        }

        // TODO: set language property
        // init language with this.state.lang

        if (callback) {
          callback();
        }
      },
    );
  }

  //legacy function which process the URL information that we get from our initial text, specifically for language and partner usages
  parseUrlParams() {
    var urlParams;
    let self = this;
    (window.onpopstate = function (event) {
      devLog("onpopstate", event, self?.state);

      // if(event?.state && typeof event.state.webAppState !== 'undefined'){
      // 	self.setState({
      // 		webAppState: event.state.webAppState
      // 	})
      // }

      var match,
        pl = /\+/g, // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
          return decodeURIComponent(s.replace(pl, " "));
        },
        query = window.location.search.substring(1);

      urlParams = {};
      // eslint-disable-next-line no-cond-assign
      while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2]);
    })();

    // check for language destination
    // we are currently relying on the old Rapitow system of
    // checking if the webapp.html, webapp_fra.html, etc is sent
    // we then set this as a url param 'lang' to be set at the state

    const pathName = window.location.pathname.toLowerCase();
    if (
      pathName.includes("webapp_spa.html") ||
      pathName.includes("feedback_spa.html") ||
      pathName.includes("webapp-ttl_spa.html")
    ) {
      urlParams.lang = "es";
    } else if (
      pathName.includes("webapp_fra.html") ||
      pathName.includes("feedback_fra.html") ||
      pathName.includes("webapp-ttl_fra.html")
    ) {
      urlParams.lang = "fr";
    } else {
      urlParams.lang = "en";
    }
    var partner = FindPartner(urlParams.lg);
    //devLog(partner)
    this.setState({ localGroupLogo: partner });
    this.setState({ partner: urlParams?.lg });

    // debug settings
    if (pathName.includes("debugmode")) {
      urlParams.debugMode = true;
    } else {
      urlParams.debugMode = false;
    }

    try {
      if (!!urlParams?.lg && !document.body.classList.contains(urlParams?.lg)) {
        document.body.classList.add(urlParams?.lg);
      }
    } catch (e) {}

    return urlParams;
  }

  //called in render to change the language of the application once the application mounts
  languageChange = (language) => {
    this.props.i18n.changeLanguage(language);
    // MemberSearchService.setLanguage(language);
  };

  // TODO DETERMINE NECESSITY OF ALL THE CURR STATE PARAMETERS TO INCREASE SPEED
  render() {
    devLog("state", this.state);
    const { t, i18n } = this.props;
    if (this.state.lang && i18n.language !== this.state.lang) {
      this.languageChange(this.state.lang);
    }

    return (
      <>
        <div className={`WebAppView ${this.state?.partner ? this.state.partner : ""}`}>
          {/* This Modal is for Error Handling Messages */}
          {this.state.ShowMessage && (
            <Dialog
              open={this.state.ShowMessage}
              title={this.state.MessageTitle}
              message={this.state.Message}
              buttonTitle={this.state.MessageButtonTitle || "HelpCallButton2"}
              secondaryButtonTitle={this.state.MessageSecondButtonTitle || null}
              secondaryButtonAction={this.state.MessageSecondAction || null}
              onUserModalConfirm={this.state.onUserModalConfirm}
              MessageButtonClass={
                this.state.partner === "FIMC" && this.state.recommendation === 5
                  ? "btn-learn-more"
                  : this.state.webAppState === AppState.ProviderEnroute
                    ? "call-provider-btn"
                    : ""
              }
              isProviderEnroute={this.state.webAppState === AppState.ProviderEnroute}
              callCallBackNumber={this.callCallBackNumber}
              preventDismiss={!!this.state.MessagePreventDismiss}
              hidePrimaryFooterButton={!!this.state.MessageHidePrimaryButton}
              onClose={() => {
                // resets modal for reuse
                this.setState({
                  MessageButtonClass: "",
                  onUserModalConfirm: undefined,
                  ShowMessage: !this.state.ShowMessage,
                  deflectionCancel: false,
                  deflectionInfo: undefined,
                  MessagePreventDismiss: false,
                  MessageHidePrimaryButton: false,
                });
              }}
            />
          )}
          {/* This Modal is for the EnRoute Help Dialog */}
          {this.state.ShowHelp && (
            <Modal open={this.state.ShowHelp} onClose={() => this.setState({ ShowHelp: false })}>
              <h2 style={{ marginTop: 30 }}>{t("description.HelpCall1")}</h2>
              <Fragment>{t("description.HelpCall2")}</Fragment>
              <h5 style={{ marginTop: 10 }}>
                <strong>{t("description.HelpCallSubHeader1")}</strong>
                {this.state.EnRouteData.status} <br />
                <strong>{t("description.HelpCallSubHeader2")}</strong>
                {this.state.EnRouteData.time} <br />
                <strong>{t("description.HelpCallSubHeader3")}</strong>
                {this.state.EnRouteData.servProv}{" "}
              </h5>

              {this.getProviderPhone && (
                <div className="footerContainer">
                  <div
                    type="hidden"
                    id="tapForRoadside"
                    onClick={this.callProvider}
                    className="footer"
                    style={{ maxWidth: 250 }}
                  >
                    <span>{t("description.HelpCallButton1")}</span>
                  </div>
                </div>
              )}

              <div className="footerContainer">
                <div
                  type="hidden"
                  id="tapForRoadside"
                  onClick={() => this.setState({ ShowHelp: false })}
                  className="footer"
                >
                  <span>{t("description.HelpCallButton2")}</span>
                </div>
              </div>
            </Modal>
          )}
          {/**
           * Begin screen routing by checking the value of `webAppState`
           */}
          {/* Locate User */}
          {this.state.webAppState === AppState.LocateUser && (
            <>
              {/* When editing the location, don't auto GeoLocate */}
              {!this.state.ReturnToConfirm && this.state.GeoLocationStatus != "SUCCESS" && (
                <TrxNowGeoLocation
                  context={this}
                  onUserDeniedLocation={this.userDeniedLocation}
                  onLocationUpdate={(locationData) => {
                    devLog("LocationData", locationData);
                    const { address, position: coords } = locationData.address;

                    let country = address.Country || address.country || address.countryCode;
                    devLog("Country:", country);
                    let twoLetterCode = country.length > 2 ? countryFind(country) : country;
                    devLog("Two Letter Code:", twoLetterCode);

                    let locationStreet = address.Label || address.label;

                    this.setState(
                      {
                        GeoLocationStatus: "SUCCESS",
                        DisablementAddress: locationStreet,
                        DisablementCoords: {
                          lat: coords.lat,
                          lng: coords.lng,
                        },
                        DisablementStreet: locationStreet.split(",")[0]
                          ? locationStreet.split(",")[0]
                          : `${address.HouseNumber || address.houseNumber} ${address.Street || address.street}`,
                        DisablementCity: address.City || address.city,
                        DisablementState: address.StateCode || address.stateCode,
                        DisablementZip: address.PostalCode || address.postalCode,
                        DisablementCountry: twoLetterCode, //address.Country || address.countryCode,
                      },
                      () => {
                        devLog("Location data", locationData);
                        devLog("2State", this.state.DisablementState);
                        devLog("2Street:", this.state.DisablementStreet);
                      },
                    );
                  }}
                />
              )}

              <TrxNowLocateUser
                context={this}
                currState={this.state}
                logo={this.state.localGroupLogo}
                disablementCoords={this.state.DisablementCoords}
                addressLabel={this.state.DisablementAddress}
                geoLocationStatus={this.state.GeoLocationStatus}
                onUserBack={this.onUserBackClicked}
                onUserNext={this.locateUserCallback}
                onUserCancel={this.cancelPendingCallCallback}
                onLocationUpdate={this.updateUserLocationCallback}
                userDeniedLocationFlag={this.state.userDeniedLocation}
              />

              {/* <Dialog
								config={true}
								title={"DialogHeader"}
								message={
									<Fragment>
										<p>{t("description.StartingDialog1")}</p>
										<ul>
											<li>{t("description.StartingList1")}</li>
											<li>{t("description.StartingList2")}</li>
											<li>{t("description.StartingList3")}</li>
											<li>{t("description.StartingList4")}</li>
											<li>{t("description.StartingList5")}</li>
										</ul>
									</Fragment>
								}
								onClose={this.startButtonPressed}
								buttonTitle={"Start"}
							/> */}
            </>
          )}
          {/* TTLocate User */}
          {this.state.webAppState === AppState.TTLocateUser && (
            <Fragment>
              <TTLocateUser
                context={this}
                currState={this.state}
                logo={this.state.localGroupLogo}
                onLocationUpdate={this.updateUserLocationCallback}
              />
            </Fragment>
          )}

          {/* Partner Promotion */}
          {this.state.webAppState === AppState.PartnerPromotion && (
            <PartnerPromotion
              context={this}
              currState={this.state}
              data={this.state}
              logo={this.state.localGroupLogo}
            />
          )}

          {/* Confirm Customer */}
          {this.state.webAppState === AppState.ConfirmCustomer && (
            <ConfirmCustomer
              context={this}
              currState={this.state}
              onUserNext={this.onConfirmCustomerNext}
              onUserBack={this.onUserBackClicked}
              onUserCancel={this.cancelPendingCallCallback}
            />
          )}
          {/* Confirm Vehicle */}
          {this.state.webAppState === AppState.ConfirmVehicle && (
            <ConfirmVehicle
              context={this}
              currState={this.state}
              localGroup={this.state.localGroup}
              onUserNext={this.confirmVehicleCallBack}
              onUserBack={this.onUserBackClicked}
              onUserCancel={this.cancelPendingCallCallback}
              allowVehicleInfoEdits={this.state.allowVehicleInfoEdits}
            />
          )}
          {/* Confirm Service */}
          {this.state.webAppState === AppState.SelectService && (
            <ConfirmService
              context={this}
              currState={this.state}
              localGroup={this.state.localGroup}
              onUserNext={this.confirmServiceCallBack}
              onUserBack={this.onUserBackClicked}
              onUserCancel={this.cancelPendingCallCallback}
            />
          )}
          {/* 
					{this.state.webAppState === AppState.SelectDestination && (
						<ConfirmDestination
							context={this}
							currState={this.state}
							company={this.state.localGroup}
							providerRef={this.state.providerRef}
							companyParams={this.state.currentCompanyParams}
							startingCoords={this.state.DisablementCoords}
							callBackFunc={this.confirmDestinationCallBack}
							backButtonFunc={this.backButtonPressed}
							t={t}
						/>
					*/}
          {/* Select Destination */}
          {this.state.webAppState === AppState.SelectDestination && (
            <SelectDestination
              context={this}
              currState={this.state}
              company={this.state.localGroup}
              providerRef={this.state.providerRef}
              companyParams={this.state.currentCompanyParams}
              startingCoords={this.state.DisablementCoords}
              onUserNext={this.confirmDestinationCallBack}
              onUserBack={this.onUserBackClicked}
              logo={this.state.localGroupLogo}
              t={t}
            />
          )}
          {/* Confirm Information */}
          {this.state.webAppState === AppState.ConfirmInformation && (
            <ConfirmInformation
              context={this}
              currState={this.state}
              data={this.state}
              logo={this.state.localGroupLogo}
              onUserNext={this.confirmInformationCallback}
              onUserBack={this.onUserBackClicked}
              onUserCancel={this.cancelPendingCallCallback}
              // confirmInfoDisab={this.confirmInfoDisabCallBack}
              // confirmInfoDest={this.confirmInfoDestCallBack}
              // backButtonFunc2={this.backButtonPressedFromConfirmInfo}
            />
          )}
          {/* Locating Provider */}
          {this.state.webAppState === AppState.LocatingProvider && (
            <LocatingProviderContainer
              context={this}
              currState={this.state}
              isAutoAccept={this.state.isAutoAccept}
              startingCoords={this.state.DisablementCoords}
              logo={this.state.localGroupLogo}
              // providerLocatedCallback={this.providerLocatedCallback}
            />
          )}
          {/* Payment Required */}
          {this.state.webAppState === AppState.PaymentRequired && (
            <PaymentRequiredContainer
              currState={this.state}
              quoteAmount={this.state.CallStatusParams.QuoteAmt}
              quoteCurrency={this.state.CallStatusParams.Currency}
              companyParams={this.state.currentCompanyParams}
              onUserCancel={this.cancelCallReqCallback}
              encCallGUID={
                // this.state.CallStatus.encCallGUID ||
                this.state.CallStatusParams.encCallGUID
              }
              localGroup={this.state.localGroup}
            />
          )}
          {/* Feedback */}
          {this.state.webAppState === AppState.Feedback && (
            <Feedback
              context={this}
              currState={this.state}
              logo={this.state.localGroupLogo}
              callBackFunc={this.feedbackConfirmedCallback}
            />
          )}
          {/* Provider Enroute */}
          {this.state.webAppState === AppState.ProviderEnroute && (
            <>
              {devLog(
                `this.state.ProviderEnRouteDest: ${this.state.ProviderEnRouteDest} \n Operator Coords: ${this.state.OperatorCoords}\n Disablement Coords: ${this.state.DisablementCoords}\n Dest Coords: ${this.state.DestinationCoords}\n`,
              )}

              <ProviderEnroute
                context={this}
                currState={this.state}
                // we are showing customer and service provider
                // or service provider and destination
                enRouteCallback={this.enRouteCallback}
                startingCoords={this.state.ProviderEnRouteDest ? this.state.OperatorCoords : this.state.CallCoords}
                destCoords={this.state.ProviderEnRouteDest ? this.state.DestinationCoords : this.state.OperatorCoords}
                enRouteDest={this.state.ProviderEnRouteDest}
                data={this.state.EnRouteData}
                logo={this.state.localGroupLogo}
                cancelFunc={this.disableCancelCallReqCallback}
                helpFunc={this.enRouteHelpButtonPressed}
              />
            </>
          )}
          {/* Temp */}
          {this.state.webAppState === AppState.Temp && <></>}

          {/* Contract Search for All Partners */}
          {this.state.webAppState === AppState.MemberSearch && (
            <GenericMemberSearch
              context={this}
              currState={this.state}
              memberSearchService={this.state.memberSearchService}
              logo={this.state.localGroupLogo}
              onUserNext={this.confirmInformationCallback}
              onUserBack={this.onUserBackClicked}
              onUserCancel={this.cancelPendingCallCallback}
              partner={this.state.partner}
              firstName={this.state.FirstName}
              lastname={this.state.LastName}
            />
          )}

          {/* Contract Information For All Partners */}
          {this.state.webAppState === AppState.MemberInformation && (
            <GenericMemberInformation
              context={this}
              currState={this.state}
              logo={this.state.localGroupLogo}
              callBackFunc={this.confirmInformationCallback}
              backButtonFunc={this.onUserBackClicked}
              onUserCancel={this.cancelPendingCallCallback}
              onUserBack={this.onUserBackClicked}
              partner={this.state.partner}
              phoneNumber={this.state.Number}
            />
          )}

          {/* Accident Confirmed for Traveler */}
          {this.state.webAppState === AppState.AccidentConfirmed && this.state.partner === "TVL" && (
            <TVLAccidentConfirmed
              context={this}
              currState={this.state}
              // logo={this.state.localGroupLogo}
            />
          )}

          {/* Accident Confirmed for Holman*/}
          {this.state.webAppState === AppState.AccidentConfirmed &&
            (this.state.partner === "ARIU" || this.state.partner === "ARIC") && (
              <ARIAccidentConfirmed
                context={this}
                currState={this.state}
                // logo={this.state.localGroupLogo}
              />
            )}
          {!!this.state.showWelcomeModal &&
            this.state.initialized &&
            !this.state.CanRunCycler &&
            this.state.CallPendingParams.CallStatus !== 24 &&
            this.state.webAppState === "Feedback" && <WelcomeModal context={this} onClose={this.startButtonPressed} />}

          {/* Debug Menu */}
          {this.state.ShowDebugControls && this.state.initialized && (
            <DebugMenu context={this} currState={this.state} />
          )}
          <p
            style={{
              position: "relative",
              zIndex: 10,
              textAlign: "center",
              color: "#aaaaaa",
              paddingTop: 20,
              fontSize: 9,
            }}
          >
            TrxNow Version 2.6.1
          </p>
        </div>

        <SplashScreen logo={this.state.localGroupLogo} disabled={this.state.initialized} />

        <ApiPendingScreen
          active={this.state.apiCallPending || this.state.cancelCallPendingLoading}
          statusText={this.state.cancelCallPendingLoading ? t("description.CancelingTheCall") : undefined}
        />
      </>
    );
  }
}
const WebAppViewMid = withTranslation()(WebAppViewPre);

export default function WebAppView() {
  return (
    <React.Suspense>
      <WebAppViewMid />
    </React.Suspense>
  );
}
